import { useState } from "react";
import { ActionPlanEntity } from "entities/RCA/ActionPlanEntity/ActionPlanEntity";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import moment from "moment";

interface IUseActionPlanDeletionProps {
    onActionPlanCreated?: () => Promise<void> | void;
    onSuccess?: (message: string) => void;
    onError?: (message: string) => void;
}

interface IUseActionPlanDeletionResult {
    actionPlanToDelete: IActionPlan | null;
    setActionPlanToDelete: (actionPlan: IActionPlan | null) => void;
    handleDeleteActionPlan: () => Promise<void>;
}

export const useActionPlanDeletion = ({
    onActionPlanCreated,
    onSuccess,
    onError,
}: IUseActionPlanDeletionProps): IUseActionPlanDeletionResult => {
    const [actionPlanToDelete, setActionPlanToDelete] = useState<IActionPlan | null>(null);
    const { updateActionPlanMutation } = ActionPlanEntity.UpdateActionPlan();

    const handleDeleteActionPlan = async (): Promise<void> => {
        if (!actionPlanToDelete) return;

        const actionPlanDetailValues = {
            deleted_at: moment.utc().toDate(),
        };

        try {
            await updateActionPlanMutation({
                variables: {
                    actionPlanId: actionPlanToDelete.action_plan_id,
                    changes: {
                        ...actionPlanDetailValues,
                    },
                },
            });
            if (onActionPlanCreated) {
                await onActionPlanCreated();
            }
            if (onSuccess) {
                onSuccess("rca.action_plans.action_plan_details.delete_success");
            }
            setActionPlanToDelete(null);
        } catch {
            if (onError) {
                onError("rca.action_plans.action_plan_details.delete_failed");
            }
            setActionPlanToDelete(null);
        }
    };

    return {
        actionPlanToDelete,
        setActionPlanToDelete,
        handleDeleteActionPlan,
    };
};
